
import {of as observableOf, combineLatest as observableCombineLatest, throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { routes } from "environments/environment";
import { map, catchError, switchMap } from "rxjs/operators";
import { LocalStorageService } from "ngx-webstorage";
import { secret } from "app/app.env";

@Injectable()
export class GenService {
  userData: any;

  constructor(private http: HttpClient, private localSt: LocalStorageService) {
    this.userData = this.localSt.retrieve(secret.userData);
  }

  parameters() {
    let codeCobra = this.localSt.retrieve(secret.userData).codeCobra;
    let url = `${routes.chat_parameters}?codecobra=${codeCobra}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        try {
          return res.data;
        } catch (error) {
          throw res;
        }
      }),
      catchError((error) => {
        return observableThrowError(error.result);
      })
    );
  }

  getParcelasWithCobra() {
    const { codeCobra } = this.userData;
    let url = `${routes.consultar_parcelas_cobra}?codecobra=${codeCobra}`;
    return this.http.get(url).pipe(
      map((res: any) => {
        try {
          // consta no parametro geral
          return res.data.installments;
        } catch (e) {
          throw res;
        }
      }),
      catchError((error) => {
        return observableThrowError(error.result);
      })
    );
  }

  getOptions(): Observable<any> {
    const { codeCobra } = this.userData;
    let url = `${routes.options}&codecobra=${codeCobra}`;

    return this.http.get(url).pipe(
      map((res: any) => {
        try {
          // consta no parametro geral
          return res.data.paymentOptions[0];
        } catch (e) {
          throw res;
        }
      }),
      catchError((error) => {
        return observableThrowError(error.result);
      })
    );
  }

  getSaldo() {
    const { codeCobra } = this.userData;

    let date = new Date();
    let month = ("00" + (date.getMonth() + 1)).slice(-2);
    let year = date.getFullYear();
    let dateNumber = ("00" + date.getDate()).slice(-2);
    let formatted_date = `${year}${month}${dateNumber}`;
    let url = `${routes.received}?codecobra=${codeCobra}&datecalculate=${formatted_date}`;

    let url_discount = `${routes.opt_parcelamento}?codecobra=${codeCobra}&datecalculate=${formatted_date}&codeoperator=ts-atende&quitter=false&calculatedefault=true`;

    let discount = this.http.get(url_discount).pipe(
      map((res: any) => {
        try {
          if (res.data) {
            return res.data;
          } else {
            throw res;
          }
        } catch (e) {
          throw res;
        }
      }),
      catchError((error) => {
        return observableThrowError(error.result);
      })
    );

    let values = this.http.get(url).pipe(
      map((res: any) => {
        try {
          if (res.data) {
            return res.data;
          } else {
            throw res;
          }
        } catch (e) {
          throw res;
        }
      }),
      catchError((error) => {
        return observableThrowError(error.result);
      })
    );

    return observableCombineLatest(values, discount).pipe(
      switchMap(([values, discount]) => {
        let all = Object.assign({}, values, discount);
        return observableOf(all);
      })
    );
  }

  getValorParcelas({
    datecalculate,
    receivedamount,
    residencefeeamount,
    latefeeamount,
    interestamount,
    rateamount,
    codeoperator,
    installmentnumber,
    quitter,
  }) {
    try {
      const { codeCobra } = this.userData;
      let url = `${routes.opt_parcelamento}?codecobra=${codeCobra}&datecalculate=${datecalculate}&receivedamount=${receivedamount}&residencefeeamount=${residencefeeamount}&latefeeamount=${latefeeamount}&interestamount=${interestamount}&rateamount=${rateamount}&codeoperator=${codeoperator}&installmentnumber=${installmentnumber}&quitter=${quitter}&calculatedefault=true`;

      return this.http.get(url).pipe(
        map((res: any) => {
          try {
            if (res.data) {
              return res.data;
            } else {
              throw res;
            }
          } catch (error) {
            throw res;
          }
        })
      );
    } catch (error) {
      return observableThrowError(error);
    }
  }

  envioProposta(dados) {
    const { codeCobra, numberContract } = this.userData;
    let nomeDevedor = this.localSt.retrieve("devedor");
    let url = `${routes.envio_email_proposals}`;

    dados["codeCobra"] = codeCobra;
    dados["contractNumber"] = numberContract;
    dados["debtor"] = nomeDevedor || "";

    return this.http.post(url, dados).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return observableThrowError(error);
      })
    );
  }

  inclusaoPropostaAcordo(dados) {
    const { codeCobra } = this.userData;
    let url = `${routes.acordo_inclusao}`;
    //dados para inclusao
    dados["codeCobra"] = codeCobra;
    dados["codeOperator"] = "ts-atende";

    return this.http.post(url, dados).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error) => {
        return observableThrowError(error);
      })
    );
  }
}
